
// SVG Icon: left
export default { id: "terriajs-left" };
export const id = "terriajs-left";
export const name = "left";
